import React from 'react';
import { Input, Label } from './Input.styled';

const InputBox = (props) => {
    return (
        <>
            {props.label ? (
                <Label showAstrisk={props.showAstrisk}>{props.label} </Label>
            ) : null}
            <Input
                placeholder={props.placeholder}
                type={props.type}
                {...props}
                autoFocus={props.autoFocus}
             
            />
        </>
    );
};
export default InputBox;
